import type {
  RetargetingDisposition,
  RetargetingFormState,
  RetargetingSegmentApiParams,
} from '@openx/types/targeting/retargeting';
import { Intersect } from '@openx/types/targeting/targetingValuesTypes';

export const emptyRetargetingFormState = (): RetargetingFormState => ({
  disposition: '',
  segment_id: '',
});

export const dispositionFromOp = (
  op: RetargetingSegmentApiParams['op'] | string | null | undefined
): RetargetingDisposition => (op === Intersect.NOT_INTERSECTS ? 'suppress' : 'target');

export const opFromDisposition = (disposition: RetargetingDisposition): RetargetingSegmentApiParams['op'] =>
  disposition === 'suppress' ? Intersect.NOT_INTERSECTS : Intersect.INTERSECTS;

export const fromRetargetingSegmentApiParams = (
  segment: RetargetingSegmentApiParams | null | undefined
): RetargetingFormState => {
  const segmentId = segment?.val?.split(',')[0]?.trim();
  if (!segmentId) {
    return emptyRetargetingFormState();
  }

  return {
    disposition: dispositionFromOp(segment?.op),
    segment_id: segmentId,
  };
};

export const toRetargetingSegmentApiParams = (form: RetargetingFormState): RetargetingSegmentApiParams | null => {
  if (!form.segment_id || !form.disposition) {
    return null;
  }

  return {
    op: opFromDisposition(form.disposition),
    val: form.segment_id,
  };
};
